module.exports = __webpack_public_path__ + "img/1.b14b24e6.png";